import React from 'react';
import { Form, Button, Table, Modal } from 'react-bootstrap';

import Tree, { TreeNode } from 'rc-tree';
import { FormattedMessage } from 'react-intl';
import { isBrowser } from 'react-device-detect';
import { I18n } from '../utils/I18n';
import MenuSortTable from '../components/MenuSortTable';
import AlertDialog from '../utils/AlertDialog';


const root = process.env.PUBLIC_URL + "/";

const Columns = {
  MajorVegetableColor: 0,
  MinorVegetableColor1: 1,
  MinorVegetableColor2: 2,
  PosName: 3,
  Price: 4,
  
};

export default class FoodMenu extends React.Component {
  constructor(props) {
    super(props);
    this.CompanyNewTreeComponent = (<div></div>);
    this.state = {
    ShowTypeTree:true,
    ShowCompanyTree:true,
    CreateTypeModal:false,
    CreatefoodModal:false,
    EditTypeModal:false,
    VisibleColumn: [true,true, true, true, true, true ],
    DeleteTypeModal:false,
    DeleteFoodModal:false,
    SortBy: 0,
    SortDESC: true,
    SearchBarValue:"",
    MenuList:[],
    NowSelectType:0,
    firstCategory:0,
    CategoryArray:[],
    CompanyNewTree:[],
    NowSelectCompanyID:0,

    IDRay:[],
    focusRay:[],
    focusDERay:[],
    NowFocusFoodName:"",
    NowFocusSubLang1:"",
    NowFocusSubLang2:"",
    NowFocusPOS:"",
    NowFocusPrice:0,

    showEditModal: false,
    showDeleteModal: false,

    CreateNewCategoryName:"",

    CreateNewFoodName:"",
    CreateNewFoodSUB1:"",
    CreateNewFoodSUB2:"",
    CreateNewFoodPOS:"",
    CreateNewFoodPrice:"",
    CreateNewFoodCategory:0,

    NowEditTypeName:"",
    NowDeleteTypeName:""

    }
    this.MenuListTableRef = React.createRef();
    this.handleSearchInputChange = this.handleSearchInputChange.bind(this);
    this.getCategoryData = this.getCategoryData.bind(this);

    console.log("init food menu");
  }
  componentDidMount(){
   this.getCategoryData()
  }
  getCategoryData=async ()=>{ 

    try {
      let res=await fetch("/api/company/subsidiary", { credentials: 'include' });
      let result=await res.json()
      console.log("公司資料::")
      // console.log(result.data)

      this.setState({ CompanyNewTree: [result.data] });
      this.setState({NowSelectCompanyID:[result.data][0].id});
      this.initNewCompanyTree();

    } catch (error) {
      console.log("error in CompanyTree init:", error)
    }


    try{
     let res =await  fetch("/api/analysis/meal/category", { credentials: 'include' })
     let result=await res.json()

     this.setState({CategoryArray:result.data})
     this.setState({firstCategory:result.data[0].id})
     let AllFoodRAYY=[];
     result.data.forEach((cat)=>{cat.mealTypeDaos.forEach((food)=>{AllFoodRAYY.push(food)})})

    let ToIDR=[];  
    let MenuRay=[];
    AllFoodRAYY.forEach((food)=>{
        if(food.secondName == null){food.secondName= "";}
        if(food.thirdName == null){food.thirdName= "";}
        let emptyD=[food.id,food.mealCategoryId,food.mainName,food.posName,food.price,food.secondName,food.thirdName];
        let emptyRay=[];
        emptyRay=[food.mainName,food.secondName,food.thirdName,food.posName,food.price.toString()];
        MenuRay.push(emptyRay)
        ToIDR.push(emptyD)
      })

      this.setState({IDRay:ToIDR})

      this.setState({MenuList:MenuRay}, () => {
        this.MenuListTableRef.current.updateRow(this.state.MenuList);
        this.MenuListTableRef.current.SortRows(0,0)
      })
     

    }catch(error){
      console.log("error in Meal category:", error)
    }
  }

  handleInputChange = (event) => {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    this.setState({ [name]: value });
  }

  Editmodalshow = (userdata) => {

    this.state.IDRay.forEach((Ray)=>{
      if(Ray[2]==userdata[0] && Ray[3]==userdata[3] && Ray[4].toString() ==userdata[4]){
        this.setState({focusRay:Ray})
      }        
      })

      this.setState({showEditModal:true});
      this.setState({NowFocusFoodName:userdata[0]})
      this.setState({NowFocusSubLang1:userdata[1]})
      this.setState({NowFocusSubLang2:userdata[2]})
      this.setState({NowFocusPOS:userdata[3]})
      this.setState({NowFocusPrice:userdata[4]})
  }

  Deletemodalshow=(userdata)=>{
    this.state.IDRay.forEach((Ray)=>{
      if(Ray[2]==userdata[0] && Ray[3]==userdata[3] && Ray[4].toString() ==userdata[4]){
        this.setState({focusDERay:Ray})
      }        
      })
    this.setState({showDeleteModal:true});

  }

  renderMenuListTable() {
    let headers = [
      I18n.t('FoodMenu.VegetableColorNameMajor'),
      I18n.t('FoodMenu.VegetableColorNameMinor1'),
      I18n.t('FoodMenu.VegetableColorNameMinor2'),
      I18n.t('FoodMenu.POSBillName'),
      I18n.t('FoodMenu.BillPrice')
    ];

    return (
      <MenuSortTable ref={this.MenuListTableRef}
        Headers={headers}
        Rows={this.state.MenuList}
        DefaultVisibleColumn={[true, true, true, true, true]}
        HasCheckBox={true}
        openEditModel={(userData) => { this.Editmodalshow(userData) }}
        openDeleteModel={(userData) => { this.Deletemodalshow(userData) }}

      />
    );
  }

  renderFooter() {
    return (
      <footer className="mt-auto w-100" style={{ borderLeft: "1px solid #ccc" }}>
        <div className="d-flex flex-row h-25" >
          <div style={{ backgroundColor: "#fff", borderTop: "1px solid #ccc", borderRight: "1px solid #ccc", paddingLeft: '10px', paddingRight: '10px' }}>
            <FormattedMessage id="userListPage.displayset" />
          </div>
          <div className="flex-fill" style={{ borderBottom: "1px solid #ccc" }} ></div>
        </div>
        <div className="h-75 p-2" style={{ backgroundColor: "#fff", borderRight: "1px solid #ccc" }}>
          <span style={{ marginLeft: "20px" }}><FormattedMessage id="userListPage.dpset.column" /></span>
          <div className="d-flex flex-wrap">
          <Form.Check type="checkbox" id="footer.CompanyTree" label={I18n.t("FoodMenu.FooterCompanyTree")} custom style={{ marginLeft: "20px" }}
               onChange={() => this.setState((prev) => ({ ShowCompanyTree: !prev.ShowCompanyTree }))} checked={this.state.ShowCompanyTree}
              />
            <Form.Check type="checkbox" id="footer.TypeTree" label={I18n.t("FoodMenu.FooterTypeTree")} custom style={{ marginLeft: "20px" }}
               onChange={() => this.setState((prev) => ({ ShowTypeTree: !prev.ShowTypeTree }))} checked={this.state.ShowTypeTree}
              />
            <Form.Check type="checkbox" id="dpset.userid" label={I18n.t("FoodMenu.VegetableColorNameMajor")} custom style={{ marginLeft: "20px" }}
              onChange={() => this.setVisableColumn(Columns.MajorVegetableColor)} checked={this.state.VisibleColumn[Columns.MajorVegetableColor]}
              />
            <Form.Check type="checkbox" id="dpset.username" label={I18n.t("FoodMenu.VegetableColorNameMinor1")} custom style={{ marginLeft: "20px" }}
               onChange={() => this.setVisableColumn(Columns.MinorVegetableColor1)} checked={this.state.VisibleColumn[Columns.MinorVegetableColor1]}
               />
            <Form.Check type="checkbox" id="dpset.org" label={I18n.t("FoodMenu.VegetableColorNameMinor2")} custom style={{ marginLeft: "20px" }}
               onChange={() => this.setVisableColumn(Columns.MinorVegetableColor2)} checked={this.state.VisibleColumn[Columns.MinorVegetableColor2]}
               />
            <Form.Check type="checkbox" id="dpset.permit" label={I18n.t("FoodMenu.POSBillName")} custom style={{ marginLeft: "20px" }}
               onChange={() => this.setVisableColumn(Columns.PosName)} checked={this.state.VisibleColumn[Columns.PosName]} 
               />
            <Form.Check type="checkbox" id="dpset.email" label={I18n.t("FoodMenu.BillPrice")} custom style={{ marginLeft: "20px" }}
             onChange={() => this.setVisableColumn(Columns.Price)} checked={this.state.VisibleColumn[Columns.Price]} 
             />

          </div>
        </div>
      </footer>
    );
  }

  setVisableColumn(column) {
    let VisibleColumn = this.state.VisibleColumn;
    VisibleColumn[column] = !VisibleColumn[column];
    this.MenuListTableRef.current.toggleVisibleColumn(column);
    this.setState({
      VisibleColumn
    });
  }

  handleSearchInputChange(e) {
    this.setState({ SearchBarValue: e.target.value });
    let NewMenuList = [];
    this.state.MenuList.forEach((food) => { 
     if ( food[0].includes(e.target.value) ){
      NewMenuList.push(food);
     }
     });
    
    this.MenuListTableRef.current.updateRow(NewMenuList);

  }

  ToChooseCategory() {
   
      let hello = this.state.CategoryArray.map(
      (category) =>{
        return(<option value={category.id} >{category.categoryName}</option>) 
      }
    )

    return hello
  }




  initNewCompanyTree=()=>{ 
    this.CompanyNewTreeComponent = (

      this.state.CompanyNewTree.map( (BigCompany)=>{
        return <TreeNode key={BigCompany.id} title={BigCompany.name}>
          {BigCompany.subsidiaries.map((Mcompany)=>{
            return <TreeNode key={Mcompany.id} title={Mcompany.name}>
            {Mcompany.subsidiaries.map((scompany)=>{
              return <TreeNode key={scompany.id} title={scompany.name}/>
            })}
</TreeNode>
          })}
        </TreeNode>

      })
    )
  }

  render () {
    return (
      <div className="d-flex align-items-end flex-column" style={{ height: "94vh", paddingTop: "20px", paddingLeft: "2%", paddingRight: "2%", paddingBottom: "0px"}}>
        {/* 第一排header Title 新增類別 新增菜色 */}
        <div className="d-flex flex-row align-items-center w-100"  >
          <h4><b><u><FormattedMessage id="FoodMenu.Title" /></u></b></h4>
          {/* 新增類別按鈕  */}
          <button className="border border-secondary text-primary"
            onClick={() => {

              this.setState({CreateNewCategoryName:""}); 
              this.setState({CreateTypeModal: true});
            }}
            style={{ backgroundColor: '#fff', marginLeft: "1%", paddingLeft: "10px", paddingRight: "10px" }}>
            <b><FormattedMessage id="FoodMenu.CreateClass" /></b></button>
            {/* 新增類別Modal  */}
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.CreateTypeModal} onHide={() => { this.setState({ CreateTypeModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.CreateClass" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>

                <div className="ml-3 mb-2 row" >
                  <text><FormattedMessage id="FoodMenu.CreateClassName" /></text> 
                  <input className="ml-3" type="text" style={{ width: "60%" }} value={this.state.CreateNewCategoryName}
                    name="CreateNewCategoryName"  onChange={this.handleInputChange}  ></input>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({CreateTypeModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {
                    let AppendCategoryTree=(res)=>{
                      let data =res.data;
                      let cateNow = this.state.CategoryArray;
                      cateNow.push(data)
                      this.setState({CategoryArray:cateNow})
                    }

                    fetch("/api/company/"+ this.state.NowSelectCompanyID.toString()+"/analysis/meal/category",
                    {
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      method: "POST",
                      body: JSON.stringify({
                        "categoryName": this.state.CreateNewCategoryName
                      })
                    })
                    .then(
                      function (res) {
                        res.json().then(
                          AppendCategoryTree.bind(this)
                          )
                      }
                    )
                    .catch(function (res) { console.log("新增category錯誤::", res) });
                      
                    this.setState({CreateTypeModal: false});
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>
          {/* 新增類別Modal結束  */}
            
          {/* 新增菜色按鈕 */}
            <button className="border border-secondary text-primary"
            onClick={() => {
             this.setState({CreateNewFoodName:""});
             this.setState({CreateNewFoodSUB1:""});
             this.setState({CreateNewFoodSUB2:""});
             this.setState({CreateNewFoodPOS:""});
             this.setState({CreateNewFoodPrice:""});

             this.setState({CreatefoodModal: true});
            }}
            style={{ backgroundColor: '#fff', marginLeft: "1%", paddingLeft: "10px", paddingRight: "10px" }}>
            <b><FormattedMessage id="FoodMenu.CreateVegetableColor" /></b></button>

          {/* 新增菜色Modal */}
          <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.CreatefoodModal} onHide={() => { this.setState({ CreatefoodModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.CreateVegetableColor" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>

              <div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.CategoryValue" /></text> 
                  <select className="ml-1" style={{ width: "60%",marginRight:"10%",marginBottom:"2%" }}
                    name="CreateNewFoodCategory"  value={this.state.CreateNewFoodCategory} onChange={this.handleInputChange} >
           { this.ToChooseCategory() }
 
                    </select></div>

                <div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.CreateVegetableColorName" /></text> 
                  <input className="ml-1" type="text" style={{ width: "60%",marginRight:"10%",marginBottom:"2%" }}
                    name="CreateNewFoodName" value={this.state.CreateNewFoodName} onChange={this.handleInputChange} ></input></div>
<div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.SubLang1" /></text> 
                  <input className="ml-1" type="text" style={{ width: "60%",marginRight:"10%",marginBottom:"2%" }}
                  value={this.state.CreateNewFoodSUB1} onChange={this.handleInputChange}
                    name="CreateNewFoodSUB1"  ></input>
                  </div>  
<div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.SubLang2" /></text> 
                  <input className="ml-1" type="text" style={{ width: "60%",marginRight:"10%",marginBottom:"2%" }}
                  value={this.state.CreateNewFoodSUB2} onChange={this.handleInputChange}
                  name="CreateNewFoodSUB2"  ></input>
                    </div>

<div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.POSModalName" /></text> 
                  <input className="ml-1" type="text" style={{ width: "60%",marginRight:"10%",marginBottom:"2%" }}
                  value={this.state.CreateNewFoodPOS} onChange={this.handleInputChange}
                  name="CreateNewFoodPOS"  ></input>
</div>

<div className="d-flex justify-content-between" >
                  <text><FormattedMessage id="FoodMenu.BillPrice" /></text> 
                  <input className="ml-1" type="text" style={{ width: "60%" ,marginRight:"10%",marginBottom:"2%"}}
                  value={this.state.CreateNewFoodPrice} onChange={this.handleInputChange} 
                  name="CreateNewFoodPrice"  ></input>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({CreatefoodModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={async() => {
               console.log(this.state.CreateNewFoodCategory)     
         if(this.state.CreateNewFoodCategory==0){
      this.setState({CreateNewFoodCategory:this.state.CategoryArray[0].id})
    }                

    let CreateNewFood = (res)=>{ 

    if (this.state.CreateNewFoodCategory==this.state.NowSelectType)
{
      let data = res.data;
      let tempMenu=this.state.MenuList;
      let newFoodRW=[data.mainName,data.secondName,data.thirdName,data.posName,data.price];
      tempMenu.push(newFoodRW);

      this.setState({MenuList:tempMenu}, () => {
        this.MenuListTableRef.current.updateRow(this.state.MenuList);
        this.MenuListTableRef.current.SortRows(0,0)
      })
    }

    }
    let PriceNum =await parseInt(this.state.CreateNewFoodPrice, 10);

    fetch("/api/company/"+ this.state.NowSelectCompanyID.toString()+"/analysis/meal/category/"+this.state.CreateNewFoodCategory.toString()+"/type",
      {
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        method: "POST",
        body: JSON.stringify({
          "posName":this.state.CreateNewFoodPOS,
          "mainName":this.state.CreateNewFoodName,
          "secondName":this.state.CreateNewFoodSUB1,
          "thirdName":this.state.CreateNewFoodSUB2,
          "price":PriceNum
        })
      })
      .then(
        function (res) {
        console.log(res)
          res.json().then(
            // 這裡開始update Menu sort table
           
            CreateNewFood.bind(this)
            )
        }
      )
      .catch(function (res) { console.log("新增Food錯誤::", res) });


                  this.setState({CreatefoodModal: false});
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>
          {/* 新增菜色Modal結束 */}
        </div>

        <div className="clearfix w-100" style={{ marginTop: "20px",width: "100%",height: "100%"}}>
        <div className="float-left d-flex flex-row" style={{ width: (isBrowser ? "70%" : "100%"),marginBottom: "1%"}}>
{/* header 第二排按鈕 */}
<Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "5px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={async()=>{

              if (this.state.NowSelectType!=0 && this.state.NowSelectCompanyID !=0 ){ 

                let TempTypeName="";

                this.state.CategoryArray.forEach((category)=>{
                  if (category.id == this.state.NowSelectType)
                  {TempTypeName= category.categoryName  }
                })


                this.setState({NowEditTypeName:TempTypeName})
                this.setState({EditTypeModal: true})}   
                else{AlertDialog.show(I18n.t("msg.foodmenu.ErrTitle"), I18n.t("msg.foodmenu.ErrCclikT"));}
              }}
            ><b><FormattedMessage id="FoodMenu.EditClass" /></b></Button>
{/* 編輯類別Modal開始 */}
<Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.EditTypeModal} onHide={() => { this.setState({ EditTypeModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.EditClass" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="ml-4 mb-2 row" >
                  <text style={{marginLeft:"5%"}}><FormattedMessage id="FoodMenu.TypeName" /></text> 
                  <input className="ml-3" type="text" style={{ width: "60%" }}
                    name="NowEditTypeName" value={this.state.NowEditTypeName}  onChange={this.handleInputChange}  ></input>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({EditTypeModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {
                    fetch("/api/company/"+this.state.NowSelectCompanyID+"/analysis/meal/category/"+this.state.NowSelectType,
                    {
                      headers: {
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                      },
                      method: "PUT",
                      body: JSON.stringify({
                        "categoryName": this.state.NowEditTypeName
                      })
                    })
                    .then(function (res) { console.log(res) })
                    .catch(function (res) { console.log(res) });

                    let UpCateArray = this.state.CategoryArray;
                    UpCateArray.forEach(element => {
                      if (element.id==this.state.NowSelectType && element.companyId == this.state.NowSelectCompanyID)
                      { element.categoryName= this.state.NowEditTypeName }
                    })

                    this.setState({CategoryArray: UpCateArray});

                    this.setState({EditTypeModal: false});
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>
{/* 編輯類別Modal結束 */}

{/* 刪除類別按鈕 */}
<Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "20px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={()=>{
                if (this.state.NowSelectType!=0 && this.state.NowSelectCompanyID !=0 ){ 

                  let TempDTypeName="";

                  this.state.CategoryArray.forEach((category)=>{
                    if (category.id == this.state.NowSelectType)
                    {TempDTypeName= category.categoryName  }
                  })

                  this.setState({NowDeleteTypeName:TempDTypeName})
                  this.setState({DeleteTypeModal: true}) }
                  else{AlertDialog.show(I18n.t("msg.foodmenu.ErrTitle"), I18n.t("msg.foodmenu.ErrCclikT"));}

                }}
            ><b><FormattedMessage id="FoodMenu.DeleteClass" /></b></Button>
{/* 刪除類別Modal */}

            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.DeleteTypeModal} onHide={() => { this.setState({ DeleteTypeModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.DeleteClass" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="row" >
              <text style={{marginLeft:"34%"}}><FormattedMessage id="FoodMenu.DeleteClass" /></text>
              <text style={{marginLeft:"2%"}}>:</text>
              <text style={{marginLeft:"2%"}}>{this.state.NowDeleteTypeName}</text> 

                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({DeleteTypeModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {
                    fetch("/api/company/"+this.state.NowSelectCompanyID+"/analysis/meal/category/"+this.state.NowSelectType,{credentials: 'include'
                    ,method: "DELETE"
                  })
                    .then(res => res.json())
                    .then(
                      (result) => {
                        console.log(result);
                      },
                      (error) => {
                      console.log("error in delete Type:",error)
                      });

                      let DpCateArray = this.state.CategoryArray;
                      DpCateArray.forEach((element, index) => {
                        if (element.id==this.state.NowSelectType && element.companyId == this.state.NowSelectCompanyID)
                        {  DpCateArray.splice(index,1) }
                      })
  
                      this.setState({CategoryArray: DpCateArray});    

                      let emptR=[];

                      this.setState({MenuList:emptR}, () => {
                        this.MenuListTableRef.current.updateRow(this.state.MenuList);
                        this.MenuListTableRef.current.SortRows(0,0)
                      })



                  this.setState({DeleteTypeModal: false});
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

{/* 刪除類別Modal結束 */}

{/* 刪除菜色按鈕 */}
<Button variant="outline-dark" className="h-100" size="sm"
              style={{ marginLeft: "20px", backgroundImage: "url('" + root + "images/button_bg.png')", backgroundSize: "100% 100%", borderWidth: "0px", backgroundColor: "rgba(0,0,0,0)" }}
              onClick={(event)=>{
            let defaultCheckedArray=this.MenuListTableRef.current.getAccountCheckBox();
            let defaultCheckedSet= new Set();
            for (let i = 0; i < defaultCheckedArray.length; i++)
            {
              defaultCheckedSet.add(defaultCheckedArray[i])
            };
            let setToArray=[];
            for(let checkbox of defaultCheckedSet.values()){
              if(checkbox!=null){
                if (checkbox.checked==true){
                  setToArray.push(true)
                }else{ setToArray.push(false); }
                   } 
            }
            let FoodIDArray = [];
            defaultCheckedSet.forEach(item => {
              if (item != null){
                FoodIDArray.push(item)
              }
            })
            event.preventDefault();

      // 從IDRay中比對出選的是那些Food
     

          FoodIDArray.forEach(item => {
            if (item.checked){
              // console.log(item.name)
             let hello= item.name.split("/");
             console.log(hello);

              
              this.state.IDRay.forEach(item => {
               if( item[2]==hello[0] && item[3]==hello[3] && item[4]==hello[4] ){
                fetch("/api/analysis/meal/category/"+ item[1] +"/type/"+item[0],{credentials: 'include'
                ,method: "DELETE"
              })
                .then(res => res.json())
                .then(
                  (result) => {
                    console.log(result);
                  },
                  (error) => {
                  console.log("error in delete Food:",error)
                  });

                  let ANNAMenuList= this.state.MenuList;

                  ANNAMenuList.forEach((row, index,objArr)=>{  
                    if (row[0]==hello[0] &&  row[3]==hello[3] && row[4]==hello[4]){
                      objArr.splice(index,1)
                    }
                  })              
     
                  this.setState({MenuList:ANNAMenuList}, () => {
                    this.MenuListTableRef.current.deleteAccountCheckBox();   
                   this.MenuListTableRef.current.updateRow(this.state.MenuList);
                   this.MenuListTableRef.current.SortRows(0,0)

                 })


               }
              })
            }
          })


               }}
            ><b><FormattedMessage id="FoodMenu.DeleteVegetableColor" /></b></Button>




        </div>
          
{/* 搜尋菜色 */}

            <div className="float-right row">
            <b>
            <FormattedMessage className="mr-2" id="FoodMenu.SearchFood"  />
            </b>
            <Form.Group controlId="searchUser" className="float-left ml-2" >
              <Form.Control className="input" type="text" size="sm" 
               value={this.state.SearchBarValue} 
               onChange={this.handleSearchInputChange}
              // value={"crtl + F 搜尋菜色"}
              
              />
            </Form.Group>
          </div>

 
          <div className="mt-auto w-100 row" style={{ height: "75%",marginLeft: "0.5%" }}>
            { this.state.ShowCompanyTree ?
          <div style={{height: "100%", width: "15%"}}>
          <Table bordered size="sm" style={{ backgroundColor: "#fff", height: "100%",width:"100%" }}>
           {/*公司樹頭部  */}
          <thead>
          <tr style={{ backgroundImage: "url('/images/bar_bg.png')", backgroundSize: "100% 100%" }}>
          <th style={{ width: "10%" }} className="text-primary">
          <FormattedMessage id="FoodMenu.CompanyClassTitle" />
          </th>
          </tr>
          </thead>
           {/*公司樹頭部結束  */}
            {/*公司樹身體  */}
          <tbody>
          <div style={{ height: "100%", overflowY: "auto" }}>
          <Tree defaultExpandAll={true} showIcon={false} showLine={true}
          onClick={async(e, node) => {
            this.setState({NowSelectCompanyID:node.props.eventKey});

            fetch("/api/company/"+node.props.eventKey +"/analysis/meal/category", { credentials: 'include' })
            .then(res => res.json())
            .then(
              (result) => {
                this.setState({CategoryArray:result.data})

                if (result.data.length==0){
                  this.setState({MenuList:[]});
                  this.MenuListTableRef.current.updateRow(this.state.MenuList);
                  this.MenuListTableRef.current.SortRows(0,0)
              }
              else{
              let AllFoodRay=[]  
              result.data.forEach((foodType) => {
                // console.log(foodType.mealTypeDaos)
                foodType.mealTypeDaos.forEach((food)=>{AllFoodRay.push(food)})
              })

              let IDR=[];
              let MenuRay=[];
              AllFoodRay.forEach((food)=>{
                  if(food.secondName == null){food.secondName= "";}
                  if(food.thirdName == null){food.thirdName= "";}
                  let emptyIDR=[food.id,food.mealCategoryId,food.mainName,food.posName,food.price,food.secondName,food.thirdName];
                  let emptyRay=[];

                  emptyRay=[food.mainName,food.secondName,food.thirdName,food.posName,food.price.toString()];
                  MenuRay.push(emptyRay)
                  IDR.push(emptyIDR)
                })
                this.setState({IDRay:IDR});
                this.setState({MenuList:MenuRay}, () => {
                  this.MenuListTableRef.current.updateRow(this.state.MenuList);
                  this.MenuListTableRef.current.SortRows(0,0)
                })

              
              }
              },
              (error) => {
                console.log("error in Meal category:", error)
              }
            );

            this.setState({CreateNewFoodCategory:0});



          }}
          >
          {this.CompanyNewTreeComponent}

          </Tree>
          </div>
          </tbody>
          </Table>
           {/*類別樹身體結束  */}
         
          </div>
        : null  
        }
                    
            {/* 類別樹區塊 */}
            { this.state.ShowTypeTree ?
          <div style={{height: "100%", width: "15%"}}>
          <Table bordered size="sm" style={{ backgroundColor: "#fff", height: "100%",width:"100%" }}>
           {/*類別樹頭部  */}
          <thead>
          <tr style={{ backgroundImage: "url('/images/bar_bg.png')", backgroundSize: "100% 100%" }}>
          <th style={{ width: "10%" }} className="text-primary">
          <FormattedMessage id="FoodMenu.ClassTitle" />
          </th>
          </tr>
          </thead>
           {/*類別樹頭部結束  */}
            {/*類別樹身體  */}
          <tbody>
          <div style={{ height: "100%", overflowY: "auto" }}>
          <Tree defaultExpandAll={true} showIcon={false} showLine={true}
           autoExpandParent={true} defaultExpandParent={true}
          onClick={async(e, node) => {
          this.setState({NowSelectType:node.props.eventKey});
          let res =await  fetch("/api/company/"+this.state.NowSelectCompanyID+"/analysis/meal/category/"+node.props.eventKey+"/type", { credentials: 'include' })
          let result=await res.json()


          if(node.props.eventKey==0){
            
            fetch("/api/company/"+this.state.NowSelectCompanyID +"/analysis/meal/category", { credentials: 'include' })
            .then(res => res.json())
            .then(
              (result) => {
                this.setState({CategoryArray:result.data})

                if (result.data.length==0){
                  this.setState({MenuList:[]});
                  this.MenuListTableRef.current.updateRow(this.state.MenuList);
                  this.MenuListTableRef.current.SortRows(0,0)
              }
              else{
              let AllFoodRay=[]  
              result.data.forEach((foodType) => {
                // console.log(foodType.mealTypeDaos)
                foodType.mealTypeDaos.forEach((food)=>{AllFoodRay.push(food)})
              })
              let IDR=[];
              let MenuRay=[];
              AllFoodRay.forEach((food)=>{
                  if(food.secondName == null){food.secondName= "";}
                  if(food.thirdName == null){food.thirdName= "";}
                  let emptyIDR=[food.id,food.mealCategoryId,food.mainName,food.posName,food.price,food.secondName,food.thirdName];
                  let emptyRay=[];
                  emptyRay=[food.mainName,food.secondName,food.thirdName,food.posName,food.price.toString()];
                  MenuRay.push(emptyRay);
                  IDR.push(emptyIDR);
                })
                this.setState({IDRay:IDR})
                this.setState({MenuList:MenuRay}, () => {
                  this.MenuListTableRef.current.updateRow(this.state.MenuList);
                  this.MenuListTableRef.current.SortRows(0,0)
                })
              }
              },
              (error) => {
                console.log("error in Meal category:", error)
              }
            );
          }
          else{
        let NowMenuRay=[];
        let IDR=[];

        result.data.forEach((food)=>{
          if(food.secondName == null){food.secondName= "";}
          if(food.thirdName == null){food.thirdName= "";}
          let emptyRay=[];
          let emptyID=[food.id,food.mealCategoryId,food.mainName,food.posName,food.price,food.secondName,food.thirdName];
          emptyRay=[food.mainName,food.secondName,food.thirdName,food.posName,food.price.toString()];
          NowMenuRay.push(emptyRay)
          IDR.push(emptyID)
        })

        this.setState({IDRay:IDR});
        this.setState({MenuList:NowMenuRay}, () => {
          this.MenuListTableRef.current.updateRow(this.state.MenuList);
          this.MenuListTableRef.current.SortRows(0,0)
        })


        }
        this.MenuListTableRef.current.deleteAccountCheckBox();  

          }}
          >
          <TreeNode key={0} title={I18n.t("FoodMenu.AllItem")}>
          {this.state.CategoryArray.map(
            (category) =>{
              return(<TreeNode key={category.id} title={category.categoryName}/>) 
            }
          )
          }
          </TreeNode>
          </Tree>
          </div>
          </tbody>
          </Table>
           {/*類別樹身體結束  */}
         
          </div>
          : null
           }
         {/* 類別樹區塊結束 */}
       

          {/*menu Sortable  */}
          <div style={{height: "100%", width: "70%"}}>

          {this.renderMenuListTable()}

          </div>
          </div>
        </div>


        {this.renderFooter()}


{/* 點擊菜色編輯modal */}
            <Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showEditModal} onHide={() => { this.setState({ showEditModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.EditVegetableColor" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="d-flex justify-content-between " style={{marginBottom: "10px"}} >
                  <text style={{marginLeft:"3%"}}><FormattedMessage id="FoodMenu.VegetableColorName" /></text> 
                  <input  type="text" style={{ width: "60%",marginRight: "10%"}} value={this.state.NowFocusFoodName}
                    name="NowFocusFoodName" onChange={this.handleInputChange}  ></input>
                </div>

                <div className="d-flex justify-content-between " style={{marginBottom: "10px"}} >
                  <text style={{marginLeft:"3%"}}><FormattedMessage id="FoodMenu.SubLang1" /></text> 
                  <input  type="text" style={{ width: "60%",marginRight: "10%" }} value={this.state.NowFocusSubLang1}
                    name="NowFocusSubLang1" onChange={this.handleInputChange}  ></input>
                </div>

                <div className="d-flex justify-content-between " style={{marginBottom: "10px"}} >
                  <text style={{marginLeft:"3%"}}><FormattedMessage id="FoodMenu.SubLang2" /></text> 
                  <input  type="text" style={{ width: "60%",marginRight: "10%" }} value={this.state.NowFocusSubLang2}
                    name="NowFocusSubLang2" onChange={this.handleInputChange}  ></input>
                </div>

                <div className="d-flex justify-content-between " style={{marginBottom: "10px"}} >
                  <text style={{marginLeft:"3%"}}><FormattedMessage id="FoodMenu.POSModalName" /></text> 
                  <input  type="text" style={{ width: "60%",marginRight: "10%" }} value={this.state.NowFocusPOS}
                    name="NowFocusPOS" onChange={this.handleInputChange}  ></input>
                </div>

                <div className="d-flex justify-content-between " style={{marginBottom: "10px"}} >
                  <text style={{marginLeft:"3%"}}><FormattedMessage id="FoodMenu.BillPrice" /></text> 
                  <input  type="text" style={{ width: "60%",marginRight: "10%" }} value={this.state.NowFocusPrice}
                    name="NowFocusPrice" onChange={this.handleInputChange}  ></input>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({showEditModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={async() => {
                    // console.log(this.state.focusRay)
                    // console.log(`company id:${this.state.NowSelectCompanyID}`)
                    // console.log(`category id:${this.state.NowSelectType}`)
                    console.log(this.state.IDRay)

                    console.log(this.state.MenuList)
                    let ANEWMenuList= this.state.MenuList;

                    ANEWMenuList.forEach((row)=>{  
                      if (row[0]==this.state.focusRay[2] && row[3]==this.state.focusRay[3] && row[4]==this.state.focusRay[4].toString()){
                        console.log("畫面比對")
                        console.log(row)
                        row[0]=this.state.NowFocusFoodName;
                        row[1]=this.state.NowFocusSubLang1;
                        row[2]=this.state.NowFocusSubLang2;
                        row[3]=this.state.NowFocusPOS;
                        row[4]=this.state.NowFocusPrice.toString();
                      }
                    })
                  this.setState({MenuList:ANEWMenuList}, () => {
                    this.MenuListTableRef.current.updateRow(this.state.MenuList);
                    this.MenuListTableRef.current.SortRows(0,0)
                  })

                 let serPrice =parseInt(this.state.NowFocusPrice, 10);

                  fetch("/api/company/"+this.state.NowSelectCompanyID+"/analysis/meal/category/"+this.state.focusRay[1]+"/type/"+this.state.focusRay[0],
                  {
                    headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json'
                    },
                    method: "PUT",
                    body: JSON.stringify({
                      "mainName":this.state.NowFocusFoodName,
                      "posName":this.state.NowFocusPOS,
                      "secondName":this.state.NowFocusSubLang1,
                      "thirdName":this.state.NowFocusSubLang2,
                      "price": serPrice

                    })
                  })
                  .then(function (res) { console.log(res) })
                  .catch(function (res) { console.log(res) });

                  this.setState({showEditModal: false});

                  }
                }
                  >
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

{/* 點擊菜色編輯modal結束 */}

{/* 點擊菜色刪除modal */}

<Modal
              aria-labelledby="contained-modal-title-vcenter"
              centered
              show={this.state.showDeleteModal} onHide={() => { this.setState({ showDeleteModal: false }) }}>
              <Modal.Header closeButton style={{ backgroundColor: "#4d94ff" }}>
                <Modal.Title style={{ color: "white", marginLeft: "40%" }}><FormattedMessage id="FoodMenu.DeleteVegetableColor" /></Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div className="ml-4 mb-2 row" >
                  <text style={{marginLeft:"27%"}}><FormattedMessage id="FoodMenu.VegetableColorName" /></text> 
                  <text className="ml-3"   >{this.state.focusDERay[2]}</text>
                </div>

              </Modal.Body>
              <Modal.Footer>
                <Button variant="secondary"
                  style={{ marginRight: "25%" }}
                  onClick={() => { this.setState({showDeleteModal: false})}}>
                  <FormattedMessage id="global.cancel" />
          </Button>
                <Button variant="primary"
                  style={{ marginRight: "25%" }}
                  onClick={() => {                    
                    
                    let ANNAMenuList= this.state.MenuList;

                    ANNAMenuList.forEach((row, index,objArr)=>{  
                      if (row[0]==this.state.focusDERay[2] && row[3]==this.state.focusDERay[3] && row[4]==this.state.focusDERay[4].toString()){
                        objArr.splice(index,1)
                      }
                    })
                  this.setState({MenuList:ANNAMenuList}, () => {
                    this.MenuListTableRef.current.updateRow(this.state.MenuList);
                    this.MenuListTableRef.current.SortRows(0,0)
                  })
                    fetch("/api/analysis/meal/category/"+this.state.focusDERay[1]+"/type/"+this.state.focusDERay[0],{credentials: 'include'
                    ,method: "DELETE"
                  })
                    .then(res => res.json())
                    .then(
                      (result) => {
                        console.log(result);
                      },
                      (error) => {
                      console.log("error in delete Food:",error)
                      }
                    );
                  this.setState({showDeleteModal: false});
                  }}>
                  <FormattedMessage id="global.ok" />
          </Button>
              </Modal.Footer>
            </Modal>

{/* 點擊菜色刪除modal結束 */}

      </div>
    );
  }




}